/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rd_Secrets_DescInputs */

const en_rd_secrets_desc = /** @type {(inputs: Rd_Secrets_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} match(es) in the files below. We keep the paths only — never the values. Rotate those keys, then purge them from git history.`)
};

const id_rd_secrets_desc = /** @type {(inputs: Rd_Secrets_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} temuan di berkas berikut. Kami hanya menyimpan path-nya, tidak pernah isinya. Rotasi kuncinya, lalu bersihkan dari riwayat git.`)
};

/**
* | output |
* | --- |
* | "{count} match(es) in the files below. We keep the paths only — never the values. Rotate those keys, then purge them from git history." |
*
* @param {Rd_Secrets_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_secrets_desc = /** @type {((inputs: Rd_Secrets_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Secrets_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_secrets_desc(inputs)
	return en_rd_secrets_desc(inputs)
});